import actions from "./actions";

const initState = {
  list: [],
  loading: false,
  error: null,
};

export default function teamSettingsReducer(state = initState, action) {
  switch (action.type) {
    case actions.GET_TEAM_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.GET_TEAM_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.list || [],
      };
    case actions.GET_TEAM_SETTINGS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case actions.UPSERT_TEAM_SETTING_REQUEST:
    case actions.TOGGLE_SYNC_REQUEST:
    case actions.CLEAR_SETTING_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actions.UPSERT_TEAM_SETTING_SUCCESS:
    case actions.TOGGLE_SYNC_SUCCESS:
    case actions.CLEAR_SETTING_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case actions.UPSERT_TEAM_SETTING_ERROR:
    case actions.TOGGLE_SYNC_ERROR:
    case actions.CLEAR_SETTING_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
}
